<template>
  <ul class="list" v-if="list && list.length">
    <CardItem v-for="item in list" :key="item.id" :info="item" />
  </ul>
  <Empty v-else />
</template>

<script>
import { apiCourseHistoryList } from '@/api/IELTScourse'
import CardItem from '../components/cardItem'
import Empty from '@/components/Empty'

export default {
  components: {
    CardItem,
    Empty
  },
  data() {
    return {
      list: []
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    async fetchList() {
      const { data } = await apiCourseHistoryList()
      this.list = data
    }
  }
}
</script>

<style scoped lang="scss">
.list {
  margin: 0 -12px;
  display: flex;
  flex-wrap: wrap;
}
</style>
